import { ReactElement } from 'react';
import { useTranslation } from 'next-i18next';
import { Link } from '@Hotels-at-Home/hah-fe-core/dist/components';

const BeddingSection = (): ReactElement => {
  const { t } = useTranslation('', { keyPrefix: '$pages.$home.$bedding' });
  const { t: tLink } = useTranslation('', { keyPrefix: '$local.$homePageLinks.$bedding' });
  return (
    <section className="bedding-section">
      <div className="column-container">
        <Link href={tLink('bedding')} className="bedding-link">
          <div className="bedding-left home-title-dark">
            <p className="bedding-text">{t('text')}</p>
            <button type="button" className="btn-plain-inverted bedding-btn">
              {t('btn')}
            </button>
          </div>
          <div className="bedding-right">
            <img
              src="/images/homePage/the-westin-heavenly-bed-bed-and-bedding-sets.webp"
              alt={t('alt')}
              className="bedding-img"
              width={904}
              height={660}
              loading="lazy"
              decoding="async"
              fetchPriority="low"
            />
            <div className="bedding-title-container">
              <h2 className="bedding-title">{t('title')}</h2>
            </div>
          </div>
        </Link>
      </div>
    </section>
  );
};

export default BeddingSection;
